<template>
  <div class="d-flex flex-row lg:mr-0 xl:mr-0">
    <div class="relative bg-white border border-zt-dark-200 rounded">
      <div class="avatar-container py-10">
        <v-card-text
          id="settings-header"
          class="justify-center flex flex-col"
          style="padding: 0;"
        >
          <div>
            <div class="flex justify-center items-center">
              <div class="relative">
                <template v-if="$store.state.avatarImage">
                  <zt-avatar
                    class="outlined "
                    :src="$store.state.avatarImage"
                    color="primary"
                    size="80px"
                  >
                  </zt-avatar>
                </template>
                <template v-else>
                  <zt-avatar
                    class="outlined"
                    :text="header.userName + header.userLastname"
                    color="primary"
                    size="80px"
                  >
                  </zt-avatar>
                </template>
                <div
                  class="action-avatar absolute top-0 bottom-0 w-full h-full flex justify-center items-center opacity-0 cursor-pointer"
                  @click="showFileChooseWindow"
                >
                  <zt-icon name="pen" class="text-zt-lg text-zt-primary-200" />
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-text class="max-w-sm mx-auto pt-0">
          <div
            class="menu-name text-zt-dark-500 text-zt-lg font-bold xl:w-3/4 lg:w-3/4 md:w-3/4 wrap ml-auto mr-auto capitalize"
          >
            {{userName}}
          </div>
          <div
            class="menu-name-email ml-auto mr-auto text-zt-base text-zt-dark-300 wrap"
          >
            {{ userMail }}
          </div>
        </v-card-text>
      </div>
    </div>
    <div class="edit-avatar" v-show="imgSrc === true">
      <div>
        <div class="button_back"></div>
        <div>
          <dwt-capture-image v-if="!isNativeVersion && showDwtCapture" ref="DWTCaptureImage" :resourcesPath="resourcePath" @change-editormode="editorMode" @register-event="addMbcEvent"/>
          <capture-image v-if="isNativeVersion" ref="DWTCaptureImage" @change-editormode="editorMode" @register-event="addMbcEvent" />
          <footer v-show="step == 0" class="pie">
            <div class="employeeInfo footerIcons">
              <button data-vs-button="rotate" @click="rotateImage">
                <em class="icon-Rotate"></em>
              </button>
              <button data-vs-button="crop" @click="cropImage">
                <em class="icon-Crop"></em>
              </button>
              <button data-vs-button="mirror" @click="mirrorImage" style="display: none;">
                <em class="icon-flip"></em>
              </button>
            </div>
            <div class="buttonsSaveImg">
              <button
                data-vs-button="back"
                type="button"
                class="btn buttonSecondaryProperties"
                style="margin-left: 0;"
                @click="backToBeforePage"
              >
                {{ $t('message.settingsComponent.header.cancelEditMode') }}
              </button>
              <button
                data-vs-button="exit-edit"
                type="button"
                class="btn buttonPrimaryProperties"
                style="margin-left: 0;"
                :disabled="disabled"
                @click="exitEditImage"
              >
                {{ $t('message.settingsComponent.header.exitEditMode') }}
              </button>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Dynamsoft from 'dwt'
import Users from '../../../apiClient/Users'
import { mapGetters } from 'vuex'
import ImageCompressor from 'image-compressor.js'
import sichernDwt from '@/components/generics/dwt/DWTCaptureImage.vue';
import CaptureImage from '@/components/generics/image-capture/CaptureImage.vue'
// import 'dwt'

export default {
  components: {
    DwtCaptureImage: sichernDwt,
    CaptureImage
  },
  provide() {
    return {
      editorMode: this.editorMode
    }
  },
  data() {
    return {
      //camera
      imgSrc: false,
      step: 0,
      loading: false,
      disabled: false,
      usersRelated: this.$store.getters.getUsersRelated,
      userProfile: {
        avatar:
          this.$store.getters.getUser.nombre.charAt(0).toUpperCase() +
          this.$store.getters.getUser.apellido.charAt(0).toUpperCase(),
        name:
          this.$store.getters.getUser.nombre.charAt(0).toUpperCase() +
          this.$store.getters.getUser.nombre.slice(1).toLowerCase() +
          ' ' +
          this.$store.getters.getUser.apellido.charAt(0).toUpperCase() +
          this.$store.getters.getUser.apellido.slice(1).toLowerCase()
      },
      switchCompanyDialog: false,
      resourcePath: process.env.VUE_APP_BASE + 'dwt-resources',
      header: {
        userName: this.$store.getters.getUser.nombre,
        userLastname: this.$store.getters.getUser.apellido,
        userMail: this.$store.getters.getUser.mail,
        userCompany: this.$store.getters.getUser.empresa.nombre,
        userIniciales:
          this.$store.getters.getUser.nombre.charAt(0) +
          this.$store.getters.getUser.apellido.charAt(0),
        userAvatar: ''
      },
      showDwtCapture: Dynamsoft.Lib.env.bMobile ? false : true,
      showNativeCapture: false
    }
  },
  computed: {
    isNativeVersion() {
      return this.$store.getters.getIsNativeVersion
    },
    ...mapGetters({ getUser: 'getUser' }),
    userMail() {
      return this.getUser.mail
    },
    userName() {
      return this.getUser.nickname ? this.getUser.nickname : this.userProfile.name;
    },
  },
  created() {
    window.scrollTo(0, 0)
    this.user = new Users()
  },
  methods: {
    addMbcEvent() {
      this.$refs.DWTCaptureImage.$on('change-image', () => {
        this.step = 0
      })

      this.$refs.DWTCaptureImage.$on('save-image', async obj => {
        this.step = 0
        const blobData = this.isNativeVersion ? obj : obj.result
        await new ImageCompressor(blobData, {
          quality: 0.5,
          maxWidth: 200,
          maxHeight: 200,
          success: async result => {
            const testBlob = result
            delete testBlob['lastModified']
            delete testBlob['lastModifiedDate']
            delete testBlob['name']
            if (testBlob.type == 'image/png' || testBlob.type == 'image/jpeg') {
              const formData = new FormData()
              formData.append('myfile', testBlob)
              formData.append('sincrop', 1)

              try {
                await this.user.uploadAvatarImage(
                  testBlob,
                  this.$store.getters.getUser.id
                )
                this.step = 0
                this.imgSrc = false
                this.disabled = false
                this.pencildisabled = false

                const avatarResponse = await this.user
                  .getAvatarImage(this.$store.getters.getUser.id)
                  .catch(err => {
                    this.disabled = false
                    this.pencildisabled = false
                    this.$swal({
                      type: 'error',
                      title: this.$t(
                        `message.errorReference.${err.response.data.response_v2.code}`
                      ),
                      showConfirmButton: true,
                      confirmButtonText: this.$t(
                        'message.settingsComponent.list.okMsg'
                      )
                    })
                  })

                if (avatarResponse.status == 200) {
                  this.$store.dispatch('clearAvatarImage')
                  this.header.userAvatar = avatarResponse.data
                  this.$swal({
                    type: 'success',
                    title: this.$t(
                      'message.settingsComponent.header.cropSuccess'
                    ),
                    timer: this.$store.getters.getTimerSweetAlert,
                    showConfirmButton: false
                  })
                  this.show = false
                  this.$emit(
                    'changeTitleHeader',
                    this.$t('message.settingsComponent.header.title')
                  )
                  this.$store.dispatch('setAvatarHeader', this.header.userAvatar)
                  this.$emit('changeAvatar', Date.now())
                }
              } catch (error) {
                this.disabled = false
                this.pencildisabled = false
                this.$swal({
                  type: 'error',
                  title: this.$t(`message.errorReference.errorImageSize`),
                  showConfirmButton: true,
                  confirmButtonText: this.$t(
                    'message.settingsComponent.list.okMsg'
                  )
                })
              }
            } else {
              this.$swal({
                type: 'error',
                title: this.$t(
                  `message.settingsComponent.camera.errorOnFormatFile`
                ),
                showConfirmButton: true,
                confirmButtonText: this.$t('message.settingsComponent.list.okMsg')
              })
            }
          }
        })
      })
    },
    async showFileChooseWindow() {
      if (this.isNativeVersion) {
        if (!this.showNativeCapture) {
          this.showNativeCapture = true
          await this.$nextTick()
        }
        this.$refs.DWTCaptureImage.openWindow()
      } else if(!this.showDwtCapture) {
        this.showDwtCapture = true
        await navigator.mediaDevices.getUserMedia({ video: true })
        this.$refs.DWTCaptureImage.openWindow()
      } else {
        this.$refs.DWTCaptureImage.openWindow()
      }
    },
    editorMode(value) {
      this.imgSrc = value
    },
    backToBeforePage() {
      this.$refs.DWTCaptureImage.close()
      this.$emit(
        'changeTitleHeader',
        this.$t('message.settingsComponent.header.title')
      )
      this.step = 0
      this.imgSrc = false
      this.disabled = false
      this.pencildisabled = false
    },
    async exitEditImage() {
      this.disabled = true
      await this.$refs.DWTCaptureImage.toSave()
    },
    cropImage() {
      this.$refs.DWTCaptureImage.activeCropTool()
    },
    rotateImage() {
      this.$refs.DWTCaptureImage.rotate()
    },
    mirrorImage() {
      this.$refs.DWTCaptureImage.mirror()
    }
  }
}
</script>

<style lang="scss" scoped>
@import './home.scss';
.mbc {
  height: 100%;
  width: 100%;
  background: $white !important;
  padding: 3.6rem 0rem 0rem 0rem !important;
}
.border-avatar {
  border: 4px solid $white;
}
.action-avatar:hover {
  opacity: 1;
  background: rgba(255, 255, 255, 0.4);
}
</style>
